/**
 * The colours that stand for fill rate and CPM wherever the two are shown —
 * the CPM & Fill tab's bars and line, its slider, and the day calendar's
 * bars, inputs and state buttons. One definition, so the two can never drift
 * apart between views.
 *
 * Fixed brand values rather than theme tokens: `info` and `warning` already
 * mean other things in this module (orange marks an override everywhere).
 * Both are light, so they colour marks, borders and tints — text stays in
 * the normal ink.
 */
export const FILL_COLOR = "#60A0B0";
export const CPM_COLOR = "#9AD1AA";

/** The same colours as a light wash, for a tinted background. */
export const FILL_TINT = "rgba(96, 160, 176, 0.12)";
export const CPM_TINT = "rgba(154, 209, 170, 0.18)";

/**
 * The lines of every "Derive … from previous years" chart, the same in each:
 * the year before the plan ("this year"), the one before that ("last year"),
 * their average, and the average where it is a prediction rather than a mean.
 */
export const PREVIOUS_YEARS_COLORS = {
	currentYear: "#1CA2BB",
	previousYear: "#005E7C",
	average: "#58DADA",
	averagePredicted: "#D9528B",
} as const;

/**
 * Monthly Budget Distribution's three states, in the month view and the
 * day/week calendar alike: a month or day rebalanced automatically, one
 * locked to a share set by hand, and one pinned to an exact amount. All
 * three are light, so — like the fill and CPM colours — they colour marks,
 * borders and tints, and text stays in the normal ink.
 */
export const SEASON_STATE_COLORS = {
	auto: "#FCA180",
	locked: "#FFD480",
	pinned: "#98C74E",
} as const;

/** The same, as a light wash for a tinted background. */
export const SEASON_STATE_TINTS = {
	auto: "rgba(252, 161, 128, 0.14)",
	locked: "rgba(255, 212, 128, 0.18)",
	pinned: "rgba(152, 199, 78, 0.14)",
} as const;
